export default __webpack_public_path__ + "static/media/Snd_C3.6b25937a.mp3";